import Model from './Model';

export default class EvaluationStudents extends Model {
    user_id;
    diploma_id;
    work_process_id;

    static apiPath() {
        console.log();
        return 'students';
    }

    toJson() {
        // When submitting an change, we need to send id's for the relations instead of the values themselves.
        const dtoIds = {
            user_id: this.user_id,
            diploma_id: this.diploma_id,
            work_process_id: this.work_process_id
        };

        return { ...this, ...dtoIds };
    }
}



// WEBPACK FOOTER //
// ./src/models/Evaluation.js